import { Options } from 'highcharts';

export const highchartScaniaTheme: Options = {
  colors: [
    cssVar('--chart-categorical-index-00'),
    cssVar('--chart-categorical-index-01'),
    cssVar('--chart-categorical-index-02'),
  ],
  time: {},
  chart: {
    backgroundColor: 'var(--tds-grey-50)',
    plotBackgroundColor: 'var(--tds-white)',
    style: {
      fontSize: '14px', // Default font size for the chart
      fontFamily: 'Scania Sans Semi Condensed',
    },
  },
  title: {
    style: {
      fontSize: '18px', // Custom font size for the main title
    },
  },
  subtitle: {
    style: {
      fontSize: '16px', // Custom font size for the subtitle
    },
  },
  xAxis: {
    crosshair: {
      width: 1, // Thickness of the crosshair
      color: cssVar('--tds-grey-300'), // Color of the crosshair
      dashStyle: 'Solid', // Style of the crosshair line (Solid, Dash, Dot, etc.)
    },
    labels: {
      style: {
        fontSize: '12px', // Custom font size for the X axis labels
      },
    },
    title: {
      style: {
        fontSize: '14px', // Custom font size for the X axis title
      },
    },
  },
  yAxis: {
    labels: {
      style: {
        fontSize: '12px', // Custom font size for the Y axis labels
      },
    },
    title: {
      style: {
        fontSize: '14px', // Custom font size for the Y axis title
      },
    },
  },
  legend: {
    itemMarginBottom: 50,
    align: 'left',
    verticalAlign: 'top',
    layout: 'horizontal',
    itemStyle: {
      fontSize: '14px', // Custom font size for the legend items
    },
  },
  tooltip: {
    shared: false,
    backgroundColor: 'transparent',
    useHTML: true,
  },
  plotOptions: {
    spline: {
      lineWidth: 3,
      dataLabels: {
        style: {
          fontSize: '12px', // Custom font size for the data labels on the spline points
        },
      },
    },

    area: {
      clip: false,
      lineWidth: 2,
      fillColor: {
        linearGradient: {
          x1: 0,
          y1: 0,
          x2: 0,
          y2: 1,
        },
        stops: [
          [0, cssVar('--chart-categorical-index-01-transparent')],
          [1, 'transparent'],
        ],
      },
    },
    // Define font sizes for other series types if necessary
  },
  exporting: {
    buttons: {
      contextButton: {
        theme: {
          fill: 'var(--tds-grey-50)',
        },
      },
    },
  },
  // ... other theme options
};

function cssVar(name: string) {
  return getComputedStyle(document.documentElement).getPropertyValue(name).trim();
}
